module.exports = __webpack_public_path__ + "static/media/info_recebimento.4d4585fa.png";